import { EnvironmentProviders, Provider } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { MessageService } from 'primeng/api';

export const primengConfig = {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: false || 'none',
            cssLayer: {
                name: 'primeng',
                order: 'normalize, primeui, primeng, fc-design-system, fc-primeng-customizations'
            }
        }
    }
};

export const vendorProviders = [provideAnimationsAsync(), providePrimeNG(primengConfig), MessageService] as (
    | Provider
    | EnvironmentProviders
)[];
